import KeywordFilter from "components/filters/Filters/KeywordFilter";
import React from "react";
import AddressFilter from "components/filters/Filters/AddressFilter";
import TagFilter from "components/filters/Filters/TagFilter";
import FinancialRiskFilter from "components/filters/Filters/FinancialRiskFilter";

interface FiltersProps {
  initialTags: server.dto.TagSmall[]
}

const Filters = (props: FiltersProps) => {
  return <>
    <KeywordFilter placeholder={RESX.GeneralLabels.Keyword} />
    <AddressFilter />
    <FinancialRiskFilter />
    <TagFilter mainArea="company" initialTags={props.initialTags} />
  </>;
};

export default Filters;